import React, { useState, useEffect } from "react";
import Datepicker from "../../fixedassetelements/datepicker/Datepicker";
import {
  AddregButton,
  FilterIcon,
  SyncButton,
  UploadFileButton,
} from "../../fixedassetelements/button/Button";

import SyncPopup from "../SyncButton/SyncButton";
import UploadExcelModal from "../common/UploadExcelModal/UploadExcelModal";
import CustomFilter from "../filterIcon/CustomFilter";
import AddPurchaseRegister from "../forms/AddPurchaseRegister/AddPurchaseRegister";
import UploadPurchaseFile from "../forms/UploadFile/UploadFile";
import PurchaseUploadedFiles from "../forms/PurchaseUploadedFiles/PurchaseUploadedFile";
import ColumnMapping from "../forms/ColumnMappingForm/ColumnMapping";
import Submapping from "../forms/SubMapping/Submapping";
import ERPModal from "../common/ERPModal/ERPModal";
import SyncERPSuccess from "../SyncButton/SyncERPSuccess";
import AppendReplaceFile from "../common/AppendReplacePopup/AppendReplacePopup";
import { purchaseListing } from "../../../Bookclosure/Services/ApiHandler";

import styles from "./PurchaseregHeader.module.css";

const PurchaseRegHeaders = ({
  setShowDataState,
  tableType,
  setTableType,
  setShowTable,
  onFiltersApplied,
  showAddRegisterModal,
  setShowAddRegisterModal,
}) => {
  const [fromDate, setFromDate] = useState("2024-01-01");
  const [toDate, setToDate] = useState("2025-01-01");

  //const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showPurchaseUploadedFiles, setShowPurchaseUploadedFiles] =
    useState(false);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [showSubMapping, setShowSubMapping] = useState(false);
  const [showERPModal, setShowERPModal] = useState(false);
  const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showAppendReplacePopup, setShowAppendReplacePopup] = useState(false);

  const [uploadAction, setUploadAction] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [PurchaseID] = useState("691c3a16b2634815b26024fb");
  const [uploadType, setUploadType] = useState(null);

  const [filterConfig, setFilterConfig] = useState([]);

  useEffect(() => {
    const fetchFilterConfig = async () => {
      try {
        const response = await purchaseListing(PurchaseID, {
          page: 1,
          pageSize: 30,
          filters: [],
        });
        if (response.data && response.data.filterAndAlignment) {
          setFilterConfig(response.data.filterAndAlignment);
        }
      } catch (error) {
        console.error("Failed to fetch filter config:", error);
      }
    };

    if (PurchaseID) {
      fetchFilterConfig();
    }
  }, [PurchaseID]);

  const handleApplyFilter = (filters) => {
    console.log("Filters received:", filters);
    setShowFilter(false);

    setShowTable(true);
    setShowDataState(false);

    if (onFiltersApplied) {
      onFiltersApplied(filters);
    }
  };

  const handleSelect = (type) => {
    if (type === "uploadExcelModal") {
      setShowAddRegisterModal(false);
      setShowUploadExcelModal(true);
    } else if (type === "erp") {
      setShowAddRegisterModal(false);
      setShowERPModal(true);
    }
  };

  const handleSelectUploadType = (type) => {
    setUploadType(type);
    setShowUploadExcelModal(false);
    setShowUploadFileModal(true);
  };

  const handleProceedToPurchaseUploadedFiles = (files) => {
    setUploadedFiles(prev => [...prev, ...files]);
    setShowUploadFileModal(false);
    setShowPurchaseUploadedFiles(true);
  };

  const handleStartMapping = () => {
  setShowPurchaseUploadedFiles(false);
  setShowColumnMapping(true);
};

  const handleContinueMapping = () => {
    setShowColumnMapping(false);
    setShowSubMapping(true);
  };

  const handleSubmitSubMapping = () => {
    setShowSubMapping(false);
    setShowPurchaseUploadedFiles(true);
  };

  const handleRemoveFile = (index) => {
   setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddFiles = () => {
    setShowUploadFileModal(true);
    setShowPurchaseUploadedFiles(false);
  }

  const handleFinish = () => {
    setShowPurchaseUploadedFiles(false);
    setShowDataState(false);
    setTableType("excel");
    setShowTable(true);
  };

  const handleSuccessERPModal = () => {
    setShowERPModal(false);
    setShowERPSuccessModal(true);
  };

  const handleERPComplete = () => {
    setShowERPSuccessModal(false);
    setShowDataState(false);
    setTableType("erp");
    setShowTable(true);
  };

  const handleAppendReplaceSelect = (action) => {
    setUploadAction(action);
    setShowAppendReplacePopup(false);
    setShowUploadExcelModal(true);
  };
  return (
    <>
      <div className={styles.header}>
        <div className={styles.rightSection}>
          <FilterIcon onClick={() => setShowFilter(true)} />

          <Datepicker
            fromDate={fromDate}
            toDate={toDate}
            onFromChange={(e) => setFromDate(e.target.value)}
            onToChange={(e) => setToDate(e.target.value)}
          />

          {tableType === "erp" && (
            <SyncButton onClick={() => setShowPopup(true)} />
          )}
          {tableType === "excel" && (
            <UploadFileButton onClick={() => setShowAppendReplacePopup(true)} />
          )}
          {tableType === null && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
        </div>
      </div>

      {showAddRegisterModal && (
        <AddPurchaseRegister
          onClose={() => setShowAddRegisterModal(false)}
          handleSelect={handleSelect}
        />
      )}

      {showUploadExcelModal && (
        <UploadExcelModal
          onClose={() => setShowUploadExcelModal(false)}
          onBack={() => {
            setShowUploadExcelModal(false);
            setShowAddRegisterModal(true);
          }}
          onSelectUploadType={handleSelectUploadType}
        />
      )}

      {showUploadFileModal && (
        <UploadPurchaseFile
          PurchaseID={PurchaseID}
          onClose={() => {
           setShowUploadFileModal(false);
           setUploadedFiles([]);
          }}
          onBack={() => {
            setShowUploadFileModal(false);
            setShowUploadExcelModal(true);
          }}
          onProceedToPurchaseUploadedFiles={
            handleProceedToPurchaseUploadedFiles
          }
        />
      )}

      {showPurchaseUploadedFiles && (
        <PurchaseUploadedFiles
          uploadedFiles={uploadedFiles}
          onBack={() => {
            setShowPurchaseUploadedFiles(false);
            setShowUploadFileModal(true);
            setUploadedFiles([]);
          }}
          onStartMapping={handleStartMapping}
          onFinish={handleFinish}
          onRemove={handleRemoveFile} 
          onAdd={handleAddFiles}
          onClose={() => {
            setShowPurchaseUploadedFiles(false);
            setUploadedFiles([]);
          }}
        />
      )}

      {showColumnMapping && (
        <ColumnMapping
          PurchaseID={PurchaseID}
          onBack={() => {
            setShowColumnMapping(false);
            setShowPurchaseUploadedFiles(true);
          }}
          onContinue={handleContinueMapping}
          onClose={() => {
            setUploadedFiles([]);
            setShowColumnMapping(false) }}
        />
      )}

      {showSubMapping && (
        <Submapping
          PurchaseID={PurchaseID}
          onBack={() => {
            setShowSubMapping(false);
            setShowColumnMapping(true);
            setUploadedFiles([]);
          }}
          onSubmitMapping={handleSubmitSubMapping}
          onClose={() => {
            setUploadedFiles([]);
            setShowSubMapping(false);
          }}
        />
      )}

      {showERPModal && (
        <ERPModal
          onClose={() => setShowERPModal(false)}
          onBack={() => {
            setShowERPModal(false);
            setShowAddRegisterModal(true);
          }}
          onProceed={handleSuccessERPModal}
        />
      )}

      {showERPSuccessModal && <SyncERPSuccess onClose={handleERPComplete} />}

      {showFilter && (
        <CustomFilter
          onClose={() => setShowFilter(false)}
          onApply={handleApplyFilter}
          filterConfig={filterConfig}
        />
      )}
      {showPopup && <SyncPopup onClose={() => setShowPopup(false)} />}

      {showAppendReplacePopup && (
        <AppendReplaceFile
          onClose={() => setShowAppendReplacePopup(false)}
          onSelectUploadType={handleAppendReplaceSelect}
        />
      )}
    </>
  );
};

export default PurchaseRegHeaders;
